import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';

const AddMeals = () => {
  const [isAdding, setIsAdding] = useState(false);
  const [message, setMessage] = useState('');

  const mealsData = [
    // South Indian Meals - VEG
    {
      name: "Masala Dosa",
      description: "Crispy rice and lentil crepe filled with spiced potato mixture, served with sambar and coconut chutney",
      mealType: "breakfast",
      cuisineType: "South Indian",
      foodCategory: "veg",
      price: 80,
      imageUrl: "https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Idli Sambar",
      description: "Soft steamed rice cakes served with hot sambar and coconut chutney",
      mealType: "breakfast",
      cuisineType: "South Indian",
      foodCategory: "veg",
      price: 70,
      imageUrl: "https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Pongal",
      description: "Creamy rice and lentil dish cooked with ghee, black pepper, and curry leaves",
      mealType: "breakfast",
      cuisineType: "South Indian",
      foodCategory: "veg",
      price: 90,
      imageUrl: "https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Sambar Rice",
      description: "Rice mixed with tangy sambar, served with papad and pickle",
      mealType: "lunch",
      cuisineType: "South Indian",
      foodCategory: "veg",
      price: 120,
      imageUrl: "https://images.unsplash.com/photo-1563379091339-03246963d4a9?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Rasam Rice",
      description: "Rice served with spicy and tangy rasam soup",
      mealType: "lunch",
      cuisineType: "South Indian",
      foodCategory: "veg",
      price: 110,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Curd Rice",
      description: "Rice mixed with yogurt, tempered with mustard seeds and curry leaves",
      mealType: "dinner",
      cuisineType: "South Indian",
      foodCategory: "veg",
      price: 100,
      imageUrl: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400&h=400&fit=crop",
      isAvailable: true
    },

    // South Indian Meals - NON-VEG
    {
      name: "Chicken Dosa",
      description: "Crispy dosa filled with spiced chicken mixture, served with sambar and chutney",
      mealType: "breakfast",
      cuisineType: "South Indian",
      foodCategory: "non-veg",
      price: 120,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Egg Curry",
      description: "Hard-boiled eggs in spicy tomato-based curry with South Indian spices",
      mealType: "lunch",
      cuisineType: "South Indian",
      foodCategory: "non-veg",
      price: 140,
      imageUrl: "https://images.unsplash.com/photo-1603133872878-684f208fb84b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Fish Curry",
      description: "Fresh fish cooked in coconut milk with South Indian spices and tamarind",
      mealType: "dinner",
      cuisineType: "South Indian",
      foodCategory: "non-veg",
      price: 180,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },

    // North Indian Meals - VEG
    {
      name: "Aloo Paratha",
      description: "Whole wheat flatbread stuffed with spiced potato filling, served with curd and pickle",
      mealType: "breakfast",
      cuisineType: "North Indian",
      foodCategory: "veg",
      price: 90,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Poha",
      description: "Flattened rice cooked with onions, peanuts, and mild spices",
      mealType: "breakfast",
      cuisineType: "North Indian",
      foodCategory: "veg",
      price: 70,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Dal Khichdi",
      description: "Rice and lentils cooked together with mild spices and ghee",
      mealType: "lunch",
      cuisineType: "North Indian",
      foodCategory: "veg",
      price: 110,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Rajma Chawal",
      description: "Red kidney beans curry served with steamed rice",
      mealType: "lunch",
      cuisineType: "North Indian",
      foodCategory: "veg",
      price: 130,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Kadhi Chawal",
      description: "Yogurt-based curry with pakoras served with rice",
      mealType: "dinner",
      cuisineType: "North Indian",
      foodCategory: "veg",
      price: 120,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Baingan Bharta",
      description: "Roasted eggplant mashed with onions, tomatoes, and spices",
      mealType: "dinner",
      cuisineType: "North Indian",
      foodCategory: "veg",
      price: 100,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },

    // North Indian Meals - NON-VEG
    {
      name: "Chicken Biryani",
      description: "Aromatic rice cooked with tender chicken and fragrant spices",
      mealType: "lunch",
      cuisineType: "North Indian",
      foodCategory: "non-veg",
      price: 200,
      imageUrl: "https://images.unsplash.com/photo-1563379091339-03246963d4a9?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Butter Chicken",
      description: "Tender chicken in rich tomato and cream gravy",
      mealType: "dinner",
      cuisineType: "North Indian",
      foodCategory: "non-veg",
      price: 180,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Mutton Curry",
      description: "Spicy mutton curry cooked with onions, tomatoes, and aromatic spices",
      mealType: "dinner",
      cuisineType: "North Indian",
      foodCategory: "non-veg",
      price: 220,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },

    // Diet Plans - VEG
    {
      name: "Oats with Nuts",
      description: "Healthy oats topped with almonds, walnuts, and honey",
      mealType: "breakfast",
      cuisineType: "Diet Plans",
      foodCategory: "veg",
      price: 120,
      imageUrl: "https://images.unsplash.com/photo-1517686469429-8bdb88b9f907?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Quinoa Bowl",
      description: "Protein-rich quinoa with grilled vegetables and light dressing",
      mealType: "lunch",
      cuisineType: "Diet Plans",
      foodCategory: "veg",
      price: 200,
      imageUrl: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Grilled Vegetables",
      description: "Assorted grilled vegetables with olive oil and herbs",
      mealType: "dinner",
      cuisineType: "Diet Plans",
      foodCategory: "veg",
      price: 150,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Greek Yogurt Bowl",
      description: "Greek yogurt with fresh fruits, granola, and honey",
      mealType: "breakfast",
      cuisineType: "Diet Plans",
      foodCategory: "veg",
      price: 140,
      imageUrl: "https://images.unsplash.com/photo-1488477181946-6428a0291777?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Lentil Soup",
      description: "Hearty lentil soup with vegetables and mild spices",
      mealType: "lunch",
      cuisineType: "Diet Plans",
      foodCategory: "veg",
      price: 130,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Steamed Fish",
      description: "Fresh fish steamed with herbs and lemon",
      mealType: "dinner",
      cuisineType: "Diet Plans",
      foodCategory: "non-veg",
      price: 180,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },

    // Diet Plans - NON-VEG
    {
      name: "Egg White Omelette",
      description: "Protein-rich egg white omelette with spinach and mushrooms",
      mealType: "breakfast",
      cuisineType: "Diet Plans",
      foodCategory: "non-veg",
      price: 110,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Grilled Chicken",
      description: "Lean grilled chicken breast with herbs and spices",
      mealType: "lunch",
      cuisineType: "Diet Plans",
      foodCategory: "non-veg",
      price: 160,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Salmon Bowl",
      description: "Grilled salmon with quinoa and steamed vegetables",
      mealType: "dinner",
      cuisineType: "Diet Plans",
      foodCategory: "non-veg",
      price: 220,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },

    // Student Plans - VEG
    {
      name: "Bread Omelette",
      description: "Simple bread with egg omelette, quick and filling",
      mealType: "breakfast",
      cuisineType: "Student Plans",
      foodCategory: "veg",
      price: 60,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Maggi Noodles",
      description: "Quick and tasty instant noodles with vegetables",
      mealType: "lunch",
      cuisineType: "Student Plans",
      foodCategory: "veg",
      price: 50,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Rice and Dal",
      description: "Simple rice with dal, basic but nutritious",
      mealType: "dinner",
      cuisineType: "Student Plans",
      foodCategory: "veg",
      price: 80,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Cornflakes with Milk",
      description: "Quick breakfast with cornflakes and cold milk",
      mealType: "breakfast",
      cuisineType: "Student Plans",
      foodCategory: "veg",
      price: 40,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Veg Sandwich",
      description: "Simple vegetable sandwich with chutney",
      mealType: "lunch",
      cuisineType: "Student Plans",
      foodCategory: "veg",
      price: 70,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Curd Rice",
      description: "Simple curd rice with pickle, easy to digest",
      mealType: "dinner",
      cuisineType: "Student Plans",
      foodCategory: "veg",
      price: 60,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },

    // Student Plans - NON-VEG
    {
      name: "Egg Sandwich",
      description: "Bread with boiled egg and vegetables",
      mealType: "breakfast",
      cuisineType: "Student Plans",
      foodCategory: "non-veg",
      price: 80,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Chicken Noodles",
      description: "Instant noodles with chicken pieces",
      mealType: "lunch",
      cuisineType: "Student Plans",
      foodCategory: "non-veg",
      price: 90,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    },
    {
      name: "Egg Curry",
      description: "Simple egg curry with rice",
      mealType: "dinner",
      cuisineType: "Student Plans",
      foodCategory: "non-veg",
      price: 100,
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      isAvailable: true
    }
  ];

  const addMeals = async () => {
    setIsAdding(true);
    setMessage('Adding meals...');
    
    try {
      const mealsCollectionRef = collection(db, 'meals');
      
      for (const meal of mealsData) {
        await addDoc(mealsCollectionRef, meal);
      }
      
      setMessage(`Successfully added ${mealsData.length} meals to the database!`);
    } catch (error) {
      console.error('Error adding meals:', error);
      setMessage(`Error adding meals: ${error.message}`);
    } finally {
      setIsAdding(false);
    }
  };

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>Add Sample Meals to Database</h2>
      <p>This will add a variety of meals for different cuisines and categories.</p>
      <button 
        onClick={addMeals} 
        disabled={isAdding}
        style={{
          padding: '12px 24px',
          fontSize: '16px',
          backgroundColor: isAdding ? '#ccc' : '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: isAdding ? 'not-allowed' : 'pointer',
          marginTop: '20px'
        }}
      >
        {isAdding ? 'Adding Meals...' : 'Add Meals to Database'}
      </button>
      {message && (
        <p style={{ marginTop: '20px', fontWeight: 'bold' }}>{message}</p>
      )}
    </div>
  );
};

export default AddMeals;
